import { Button } from "@material-ui/core";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import React, { Fragment } from "react";
import Prompt from "../../components/Prompt";
import adminStore from "../../stores/adminStore";
import DataTable from "./../../components/DataTable";
import Confirm from "../../components/Confirm";
@observer
class Areas extends React.Component {
  state = {
    isPromptOpened: false,
    isConfirmOpened: false,
    activeArea: {},
  };

  closeModal() {
    this.setState({
      isPromptOpened: false,
      isConfirmOpened: false,
      activeArea: {},
    });
  }

  render() {
    const { areas } = adminStore;
    if (!areas) {
      return <div></div>;
    }
    return (
      <Fragment>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            this.setState({ isPromptOpened: true, activeArea: {} })
          }
        >
          Nueva Area
        </Button>
        <Prompt
          isOpen={this.state.isPromptOpened}
          field={{
            type: "text",
            label: "Area",
            value: this.state.activeArea.name,
          }}
          placeholder={this.state.activeArea.name}
          title={"Area"}
          onClose={this.closeModal}
          onSubmit={async (name) => {
            await adminStore.submitArea({ ...this.state.activeArea, name });
            this.closeModal();
          }}
        />
        <Confirm
          isOpen={this.state.isConfirmOpened}
          onNo={() => this.closeModal()}
          onYes={async () => {
            await adminStore.deleteArea(this.state.activeArea.id);
            this.closeModal();
          }}
          onClose={() => this.closeModal()}
          title="Atencion"
          text={`Esta accion borrar al area ${this.state.activeArea.name}, desea continuar?`}
        />
        <DataTable
          data={areas}
          fields={["id", "name"]}
          fieldNames={{
            id: "#",
            name: "Nombre",
          }}
          onEdit={(area) => {
            this.setState({
              isPromptOpened: true,
              activeArea: toJS(area),
            });
          }}
          onDelete={(area) =>
            this.setState({
              isConfirmOpened: true,
              activeArea: area,
            })
          }
        />
      </Fragment>
    );
  }
}

export { Areas };
